import type { ActivityFeedFilterOption } from '../types/activityFeed';

export const ACTIVITY_FEED_EVENT_TYPE_OPTIONS: ActivityFeedFilterOption[] = [
  { value: 'store.created', label: 'Store Created' },
  { value: 'store.updated', label: 'Store Updated' },
  { value: 'store.deleted', label: 'Store Deleted' },
  { value: 'store.user.invited', label: 'User Invited' },
  { value: 'store.user.removed', label: 'User Removed' },
  { value: 'subscription.activated', label: 'Subscription Activated' },
  { value: 'subscription.payment.succeeded', label: 'Payment Succeeded' },
  { value: 'subscription.payment.failed', label: 'Payment Failed' },
  { value: 'audit.created', label: 'Audit Created' },
  { value: 'receipt_audit.status.finalized', label: 'Receipt Audit Finalized' },
  { value: 'purchase.uploaded', label: 'Purchase Uploaded' },
  { value: 'purchase.status.processed', label: 'Purchase Processed' },
  { value: 'inventory.adjustment.created', label: 'Inventory Adjustment Created' },
  { value: 'pricebook.queue.updated', label: 'Pricebook Queue Updated' },
  { value: 'agent.heartbeat.upserted', label: 'Agent Heartbeat Received' },
  { value: 'lotto.daily_summary.created', label: 'Lotto Daily Summary Created' },
  { value: 'lotto.daily_summary.updated', label: 'Lotto Daily Summary Updated' },
  { value: 'lotto.daily_detail.created', label: 'Lotto Daily Detail Created' },
  { value: 'lotto.daily_detail.updated', label: 'Lotto Daily Detail Updated' },
  { value: 'incoming_email.received', label: 'Incoming Email Received' },
  { value: 'incoming_email.processed', label: 'Incoming Email Processed' },
  { value: 'incoming_email.ignored', label: 'Incoming Email Ignored' },
  { value: 'incoming_email.failed', label: 'Incoming Email Failed' },
  { value: 'incoming_email.invalid', label: 'Incoming Email Invalid' },
  { value: 'user.login.otp_verified', label: 'User Logged In (OTP)' },
  { value: 'user.created', label: 'User Created' },
  { value: 'user.auth.login_requested', label: 'Login Requested' },
  { value: 'user.auth.otp_generated', label: 'OTP Generated' },
  { value: 'user.auth.otp_sent', label: 'OTP Sent' },
  { value: 'user.auth.otp_verified', label: 'OTP Verified' },
  { value: 'user.auth.otp_failed', label: 'OTP Verification Failed' },
  { value: 'user.auth.token_refreshed', label: 'Token Refreshed' },
  { value: 'user.auth.token_refresh_failed', label: 'Token Refresh Failed' },
  { value: 'user.auth.logout', label: 'User Logged Out' },
  { value: 'audit.pack.marked_sold_out', label: 'Pack Marked Sold Out' },
  { value: 'receipt_audit.submitted', label: 'Receipt Submitted' },
  { value: 'receipt_audit.status.processing', label: 'Receipt Processing Started' },
  { value: 'receipt_audit.status.ready', label: 'Receipt Ready For Review' },
  { value: 'receipt_audit.status.rejected', label: 'Receipt Rejected' },
  { value: 'receipt_audit.status.failed', label: 'Receipt Processing Failed' },
  { value: 'receipt_audit.status.auto_created', label: 'Receipt Auto Created' },
  { value: 'agent.config.updated', label: 'Agent Config Updated' },
  { value: 'agent.params.updated', label: 'Agent Parameters Updated' },
  { value: 'agent.log.uploaded', label: 'Agent Log Uploaded' },
  { value: 'incoming_email.processing', label: 'Incoming Email Processing' },
  { value: 'incoming_email.reprocessing', label: 'Incoming Email Reprocessing' },
  { value: 'pos.store_close.processed', label: 'POS Store Close Processed' },
  { value: 'pos.pjr.ingested', label: 'POS Journal Ingested' },
  { value: 'pos.verifone_transset.ingested', label: 'Verifone Transaction File Processed' },
  { value: 'pos.passport_data_maintenance.processed', label: 'Passport Data Maintenance Processed' },
  { value: 'pos.ittack.processed', label: 'ITTACK Processed' },
  { value: 'pos.itt.processed', label: 'ITT Processed' },
  { value: 'pricebook.confirmation.success', label: 'Pricebook Confirmation Succeeded' },
  { value: 'pricebook.confirmation.fail', label: 'Pricebook Confirmation Failed' },
  { value: 'fuel_price.confirmation.success', label: 'Fuel Price Confirmation Succeeded' },
  { value: 'fuel_price.confirmation.fail', label: 'Fuel Price Confirmation Failed' },
  { value: 'pos.manual_lotto_sales.created', label: 'Manual Lotto Sales Entry Created' },
  { value: 'pos.manual_payout.created', label: 'Manual Payout Entry Created' },
  { value: 'store.credentials.set', label: 'Store Credentials Set' },
  { value: 'store.credentials.deleted', label: 'Store Credentials Deleted' },
];

export const ACTIVITY_FEED_EVENT_CATEGORY_OPTIONS: ActivityFeedFilterOption[] = [
  { value: 'store', label: 'Store' },
  { value: 'membership', label: 'Membership' },
  { value: 'subscription', label: 'Subscription' },
  { value: 'audit', label: 'Audit' },
  { value: 'purchase', label: 'Purchase' },
  { value: 'inventory', label: 'Inventory' },
  { value: 'pricebook', label: 'Pricebook' },
  { value: 'agent', label: 'Agent' },
  { value: 'system', label: 'System' },
  { value: 'security', label: 'Security' },
  { value: 'user', label: 'User' },
  { value: 'integration', label: 'Integration' },
];
